








































































































































import { Vue, Prop, Component } from 'vue-property-decorator';
import moment from 'moment';
import DateFormat from '@/shared/utils/date-format';
import TextFieldAreaReadonlyInput from '@/shared/text-field/text-field-area-readonly-input.component.vue';
import TextFieldAreaBasicInput from '@/shared/text-field/text-field-area-basic-input.component.vue';
import MainButton from '@/shared/buttons/main-button.component.vue';
import Rules from '@/shared/rules/rules';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import ContractInstance from '@/domain/contract/entity/contract-instance.entity';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import InstanceService from '@/domain/contract/service/instance.service';
import BindInstance from '../../../domain/contract/entity/bind-instance.entity';

@Component({
  components: {
    TextFieldAreaReadonlyInput,
    TextFieldAreaBasicInput,
    MainButton,
    VbTooltipSlot,
    ModalWarning,
  },
})
export default class ContractInfoModalNewInstance extends Vue {
  @Prop({
    required: true,
  })
  showModal!: boolean;

  @Prop({
    required: false,
    default: () => BindInstance.of({}),
  })
  instance!: BindInstance;

  @Prop({ required: true }) businessUnitId!: string;

  @Prop({ required: true }) contractId!: string;

  dateMenu: boolean = false;

  impactCheckLoading: boolean = false;

  showDateConfirmModal: boolean = false;

  impactedCompetences: string[] = [];

  get formattedStartedAt(): string {
    if (!this.persistBindInstance.startedAt) return '';
    return moment(this.persistBindInstance.startedAt).format('DD/MM/YYYY');
  }

  get startedAtChanged(): boolean {
    return !this.instance.isNew
      && this.persistBindInstance.startedAt.substring(0, 10) !== (this.instance.startedAt || '').substring(0, 10);
  }

  get dateConfirmMessage(): string {
    return 'A nova data de vigência afeta '
      + `<strong>${this.impactedCompetences.length}</strong> competência(s) que já possuem nota fiscal emitida `
      + `(${this.impactedCompetences.join(', ')}). Deseja realmente confirmar a alteração?`;
  }

  checkDateImpactAndSave(): void {
    this.impactCheckLoading = true;
    InstanceService.getDateChangeImpact(
      this.businessUnitId, this.contractId, this.instance.id, this.persistBindInstance.startedAt,
    )
      .then((impacts) => {
        const withInvoice = impacts.filter((impact) => impact.hasInvoiceEmitted);
        if (withInvoice.length === 0) {
          this.persistBindInstance.startedAtChangeConfirmed = true;
          this.sendEvent();
          return;
        }
        this.impactedCompetences = withInvoice.map((impact) => impact.competence);
        this.showDateConfirmModal = true;
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.impactCheckLoading = false;
      });
  }

  confirmDateChange(): void {
    this.showDateConfirmModal = false;
    this.persistBindInstance.startedAtChangeConfirmed = true;
    this.sendEvent();
  }

  eventType(): string {
    if (this.instance.isNew) return 'bindInstance';
    return this.persistBindInstance.active ? 'activateInstance' : 'unbindInstance';
  }

  sendEvent() {
    if (!this.$refs.form.validate()) {
      return;
    }
    this.$emit(this.eventType(), this.persistBindInstance);
  }

  $refs!: any;

  rules: Rules = new Rules();

  warningModal: boolean = false;

  warningMessage: string = 'Deseja realmente <strong style="color: orange">inativar</strong> a instância? '
    + 'Ao clicar no botão Sim, as alterações serão imediatamente realizadas.';

  persistBindInstance: BindInstance = BindInstance.of(this.instance);

  get modalState() {
    return this.showModal;
  }

  set modalState(value: boolean) {
    this.$emit('updateModalState', value);
  }

  content(active: boolean) {
    return active ? 'Inativar instância' : 'Ativar instância';
  }

  updateWarningModalState(state: boolean): void {
    this.warningModal = state;
  }

  saveInstance(): void {
    if (this.instance.active && !this.persistBindInstance.active) {
      this.updateWarningModalState(true);
      return;
    }
    if (this.startedAtChanged) {
      this.checkDateImpactAndSave();
      return;
    }
    this.sendEvent();
  }

  get title(): string {
    return this.instance.isNew ? 'Inserir' : 'Editar';
  }

  get saveButtonText(): string {
    if (!this.instance.isActive && this.persistBindInstance.isActive) return 'Ativar';
    return 'Salvar';
  }
}
